// Centralized Google reviews configuration for "Irremplaçable - Soins Animaliers"
// CID derived from the Google Maps listing provided by the owner.
export const GOOGLE_REVIEWS = {
  rating: 5.0,
  ratingLabel: '5,0',
  count: 35,
  // Opens the Google listing (reviews visible + "Rédiger un avis" button available)
  viewUrl: 'https://www.google.com/maps?cid=15935812338439882656',
  // Direct-ish link that opens the listing where the review can be written
  writeUrl: 'https://www.google.com/maps?cid=15935812338439882656',
};
